const ID_RECENT_PRODUCT = 'js-recentProduct'
import { RECENTLY_VIEWED_PRODUCTS } from '~/js/constants/local-storage-keys'

document.addEventListener('DOMContentLoaded', () => {
  const elementRecentProduct = document.getElementById(ID_RECENT_PRODUCT)
  if (!elementRecentProduct) return

  const currentProduct = JSON.parse(elementRecentProduct.dataset.product)
  if (currentProduct.type.includes('予約品')) return

  const localStorageProductArray = JSON.parse(
    localStorage.getItem(RECENTLY_VIEWED_PRODUCTS) || '[]'
  )

  const newProductArray = [currentProduct]
  localStorageProductArray.forEach((product) => {
    if (!newProductArray.map((p) => p.id).includes(product.id)) {
      newProductArray.push(product)
    }
  })

  localStorage.setItem(
    RECENTLY_VIEWED_PRODUCTS,
    JSON.stringify(newProductArray.splice(0, 50))
  )
})
